import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../lib/utils.js";
import { brand } from "../tokens/palette.js";
import { logoShapes } from "./logo-data.js";
const TONES = {
    color: { letters: brand.navy, dot: brand.violet },
    white: { letters: brand.white, dot: brand.violetLight },
    navy: { letters: brand.navy, dot: brand.navy },
    'mono-white': { letters: brand.white, dot: brand.white },
    black: { letters: '#000000', dot: '#000000' },
    current: { letters: 'currentColor', dot: 'currentColor' },
};
/** Logo Paguz vectorial e inline. El logo no se tematiza por tenant: siempre usa los colores de marca. */
function PaguzLogo({ variant = 'wordmark', tone = 'color', title = 'Paguz', className, ...props }) {
    const shape = logoShapes[variant];
    const colors = TONES[tone];
    const decorative = title === '';
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: shape.viewBox, role: decorative ? undefined : 'img', "aria-hidden": decorative || undefined, "aria-label": decorative ? undefined : title, "data-slot": "paguz-logo", className: cn(variant === 'wordmark' ? 'h-8 w-auto' : 'size-8', className), ...props, children: _jsxs("g", { transform: shape.transform, children: [shape.letters.map((glyph) => (_jsx("path", { transform: `translate(${glyph.x},0)`, fill: colors.letters, d: glyph.d }, glyph.x))), _jsx("path", { transform: `translate(${shape.dot.x},0)`, fill: colors.dot, d: shape.dot.d })] }) }));
}
export { PaguzLogo };
//# sourceMappingURL=logo.js.map